import script from "./StickersToolsItems.vue?vue&type=script&setup=true&lang=js"
export * from "./StickersToolsItems.vue?vue&type=script&setup=true&lang=js"

import "./StickersToolsItems.vue?vue&type=style&index=0&id=044dfa08&lang=scss"

const __exports__ = script;

export default __exports__